// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"409":"e61781a7","736":"0f8360d2"}[chunkId] + ".chunk.css";
};